var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MySymbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-2.000000, -2.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atoms-/-Icons-/-House-/-01.-Outline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7777778,2 L4.22222222,2 C3,2 2,3 2,4.22222222 L2,19.7777778 C2,21 3,22 4.22222222,22 L19.7777778,22 C21,22 22,21 22,19.7777778 L22,4.22222222 C22,3 21,2 19.7777778,2 Z M20.28,20.28 L3.72,20.28 L3.72,3.72 L20.28,3.72 L20.28,20.28 Z M7.55555556,9.77777778 C8.16920528,9.77777778 8.66666667,10.2752392 8.66666667,10.8888889 L8.66666667,16.4444444 C8.66666667,17.0580942 8.16920528,17.5555556 7.55555556,17.5555556 C6.94190583,17.5555556 6.44444444,17.0580942 6.44444444,16.4444444 L6.44444444,10.8888889 C6.44444444,10.2752392 6.94190583,9.77777778 7.55555556,9.77777778 Z M12,6.44444444 C12.6136497,6.44444444 13.1111111,6.94190583 13.1111111,7.55555556 L13.1111111,16.4444444 C13.1111111,17.0580942 12.6136497,17.5555556 12,17.5555556 C11.3863503,17.5555556 10.8888889,17.0580942 10.8888889,16.4444444 L10.8888889,7.55555556 C10.8888889,6.94190583 11.3863503,6.44444444 12,6.44444444 Z M16.4444444,13.1111111 C17.0580942,13.1111111 17.5555556,13.6085725 17.5555556,14.2222222 L17.5555556,16.4444444 C17.5555556,17.0580942 17.0580942,17.5555556 16.4444444,17.5555556 C15.8307947,17.5555556 15.3333333,17.0580942 15.3333333,16.4444444 L15.3333333,14.2222222 C15.3333333,13.6085725 15.8307947,13.1111111 16.4444444,13.1111111 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendor);
export default __webpack_public_path__ + "static/media/vendor.b96178457e03d69f0434fa01b9ca7741.svg";
export { ForwardRef as ReactComponent };